<template>
  <div v-if="result" class="py-4 px-6" style="border: 1px solid #cdcdcd; border-radius: 5px;">
    <div class="pt-4 grid justify-center">
      <div class="flex justify-center ">
        <svg v-if="result.passed" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#28C76F"/>
          <g clip-path="url(#clip0_41878_113879)">
            <path d="M20.4002 29.0393L15.3602 23.9993L13.6802 25.6793L20.4002 32.3993L34.8002 17.9993L33.1202 16.3193L20.4002 29.0393Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_41878_113879">
              <rect width="28.8" height="28.8" fill="white" transform="translate(9.6001 9.59961)"/>
            </clipPath>
          </defs>
        </svg>

        <svg v-else width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24.5" r="24" fill="#EA5455"/>
          <g clip-path="url(#clip0_41878_144042)">
            <path d="M32.8 17.692L31.108 16L24.4 22.708L17.692 16L16 17.692L22.708 24.4L16 31.108L17.692 32.8L24.4 26.092L31.108 32.8L32.8 31.108L26.092 24.4L32.8 17.692Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_41878_144042">
              <rect width="28.8" height="28.8" fill="white" transform="translate(10 10)"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div>
        <h3 class="text-2xl font-bold text-center mt-4">{{ `‘${result.name}’의 ‘${result.title}’` }}</h3>
        <h3 class="text-2xl font-bold text-center mt-2">{{ `시험응시 결과 ` }}
          <span v-if="result.passed" style="color: #28C76F; font-weight: 700">합격</span>
          <span v-else style="color: #EA5455; font-weight: 700">불합격</span>
          {{ `입니다.` }}</h3>

        <div style="font-size: 15px;">
          <p class="text-center mt-6">
            <span style="font-weight: 500">정답 : </span>
            <span>{{result.successCount}}문항/{{result.successCount + result.failCount}}문항</span>
          </p>
          <p v-if="result.passed" class="text-center mt-2">
            <span style="font-weight: 500">교육이수일 : </span>
            <span>{{ result.교육이수일 }}</span>
          </p>
          <p v-if="result.passed" class="text-center mt-2">
            <span style="font-weight: 500">교육만료일 : </span>
            <span>{{ result.교육만료일 }}</span>
          </p>
          <p v-if="!result.passed && result.기존합격유지" class="text-center mt-2" style="color: #7e72f2">
            기존 합격 기록은 교육만료일({{ result.기존교육만료일 }})까지 유지됩니다.
          </p>
          <p v-if="!result.passed" class="text-center mt-2">시험에 다시 응시해주세요.</p>
        </div>
      </div>

    </div>
    <div class="mt-8 flex justify-center gap-2">
      <vs-button color="#AEB1B6" @click="$emit('close')">닫기</vs-button>
      <vs-button color="#00CFE8" @click="$emit('review')">결과보기</vs-button>
      <vs-button v-if="!result.passed" color="#7E72F2" @click="$emit('retry')">재응시</vs-button>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    result: Object,
  },
  methods: {

  },
}
</script>



<style scoped lang="scss">

</style>
